module.exports = __webpack_public_path__ + "toBride2-we-b-w.560d55ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-b-w.jpg
// module id = KsNw
// module chunks = 0